import React from "react";

const ExerciseScheduleForm = ({ formData, setFormData, isSubmitting, handleChange, addRow, removeRow }) => {
    const handleRowChange = (index, field, value) => {
        const newRows = [...formData.scheduleRows];
        newRows[index][field] = value;
        // Use setFormData if passed, otherwise use handleChange
        if (setFormData) {
            setFormData(prev => ({ ...prev, scheduleRows: newRows }));
        } else {
            handleChange({ target: { name: "scheduleRows", value: newRows } });
        }
    };

    const handlePhysicalChange = (index, activity, field, value) => {
        const newRows = [...formData.scheduleRows];
        if (!newRows[index].physicalActivities) newRows[index].physicalActivities = {};
        newRows[index].physicalActivities[activity] = {
            ...newRows[index].physicalActivities[activity],
            [field]: value
        };
        // Use setFormData if passed, otherwise use handleChange
        if (setFormData) {
            setFormData(prev => ({ ...prev, scheduleRows: newRows }));
        } else {
            handleChange({ target: { name: "scheduleRows", value: newRows } });
        }
    };

    const handleGymChange = (index, exercise, field, value) => {
        const newRows = [...formData.scheduleRows];
        if (!newRows[index].gymExercises) newRows[index].gymExercises = {};
        newRows[index].gymExercises[exercise] = {
            ...newRows[index].gymExercises[exercise],
            [field]: value
        };
        // Use setFormData if passed, otherwise use handleChange
        if (setFormData) {
            setFormData(prev => ({ ...prev, scheduleRows: newRows }));
        } else {
            handleChange({ target: { name: "scheduleRows", value: newRows } });
        }
    };

    const physicalActivities = ["Stretching Exercise", "Walking", "Strengthening Exercise"];
    const gymExercises = ["Tread Mill", "Bi-Cycle", "Any Sport Activity"];

    return (
        <>
            <div className="p-3" style={{ maxHeight: "65vh", overflowY: "auto", scrollbarWidth: "thin" }}>
                {/* Client Information */}
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-4 text-center">
                    Client Information
                </small>

                <div className="row g-3 mb-5">
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="weight" value={formData.weight || ""} onChange={handleChange} />
                            <label>Weight</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="bmi" value={formData.bmi || ""} onChange={handleChange} />
                            <label>BMI</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="goal" value={formData.goal || ""} onChange={handleChange} />
                            <label>Goal</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="plan" value={formData.plan || ""} onChange={handleChange} />
                            <label>Plan</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="clientName" value={formData.clientName || ""} onChange={handleChange} />
                            <label>Client Name</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="responsibleStaff" value={formData.responsibleStaff || ""} onChange={handleChange} />
                            <label>Responsible Staff</label>
                        </div>
                    </div>
                </div>

                {/* Exercise Schedule - Row Repeater */}
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-4 px-4 text-center">
                    Weekly Exercise Schedule
                </small>

                {formData.scheduleRows?.map((row, index) => (
                    <div key={index} className="card mb-4 p-4 border shadow-sm">
                        <div className="row g-3 align-items-center mb-3">
                            <div className="col-md-3">
                                <div className="form-floating form-floating-outline">
                                    <input type="date" className="form-control" value={row.date || ""} onChange={(e) => handleRowChange(index, "date", e.target.value)} />
                                    <label>Date</label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-floating form-floating-outline">
                                    <input type="time" className="form-control" value={row.time || ""} onChange={(e) => handleRowChange(index, "time", e.target.value)} />
                                    <label>Time</label>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-floating form-floating-outline">
                                    <input type="text" className="form-control" value={row.weeklyOutcome || ""} onChange={(e) => handleRowChange(index, "weeklyOutcome", e.target.value)} />
                                    <label>Weekly Outcome</label>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-floating form-floating-outline">
                                    <input type="text" className="form-control" value={row.staffName || ""} onChange={(e) => handleRowChange(index, "staffName", e.target.value)} />
                                    <label>Staff Name</label>
                                </div>
                            </div>
                            <div className="col-md-1 text-end">
                                <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => removeRow(index)}>
                                    <i className="ri-delete-bin-line"></i>
                                </button>
                            </div>
                        </div>

                        {/* Physical Activities Collapsible */}
                        <div className="accordion mb-3" id={`physicalAccordion${index}`}>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target={`#physical${index}`}>
                                        Physical Activities
                                    </button>
                                </h2>
                                <div id={`physical${index}`} className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <div className="row g-3">
                                            {physicalActivities.map((activity) => (
                                                <div className="col-md-4" key={activity}>
                                                    <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-3 px-4 text-center">
                                                        {activity}
                                                    </small>
                                                    <div className="d-flex gap-3 justify-content-center align-items-center">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name={`physical_${index}_${activity}`} id={`yes_${index}_${activity}`} value="yes" checked={row.physicalActivities?.[activity]?.done === "yes"} onChange={(e) => handlePhysicalChange(index, activity, "done", e.target.value)} />
                                                            <label className="form-check-label cursor-pointer" htmlFor={`yes_${index}_${activity}`}>Yes</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name={`physical_${index}_${activity}`} id={`no_${index}_${activity}`} value="no" checked={row.physicalActivities?.[activity]?.done === "no"} onChange={(e) => handlePhysicalChange(index, activity, "done", e.target.value)} />
                                                            <label className="form-check-label cursor-pointer" htmlFor={`no_${index}_${activity}`}>No</label>
                                                        </div>
                                                    </div>
                                                    {row.physicalActivities?.[activity]?.done === "yes" && (
                                                        <div className="mt-2">
                                                            <input type="text" className="form-control form-control-sm" placeholder="Duration (e.g., 30 min)" value={row.physicalActivities?.[activity]?.duration || ""} onChange={(e) => handlePhysicalChange(index, activity, "duration", e.target.value)} />
                                                        </div>
                                                    )}
                                                    {row.physicalActivities?.[activity]?.done === "no" && (
                                                        <div className="mt-2">
                                                            <input type="text" className="form-control form-control-sm" placeholder="Reason" value={row.physicalActivities?.[activity]?.reason || ""} onChange={(e) => handlePhysicalChange(index, activity, "reason", e.target.value)} />
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Gym Exercises Collapsible */}
                        <div className="accordion" id={`gymAccordion${index}`}>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target={`#gym${index}`}>
                                        Gym Exercises
                                    </button>
                                </h2>
                                <div id={`gym${index}`} className="accordion-collapse collapse">
                                    <div className="accordion-body">
                                        <div className="row g-3">
                                            {gymExercises.map((exercise) => (
                                                <div className="col-md-4" key={exercise}>
                                                    <small className="text-dark bg-secondary-subtle rounded-4 fw-bold d-block mb-3 px-4 text-center">
                                                        {exercise}
                                                    </small>
                                                    <div className="d-flex gap-3 d-flex gap-3 justify-content-center align-items-center">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name={`gym_${index}_${exercise}`} id={`gym_yes_${index}_${exercise}`} value="yes" checked={row.gymExercises?.[exercise]?.done === "yes"} onChange={(e) => handleGymChange(index, exercise, "done", e.target.value)} />
                                                            <label className="form-check-label cursor-pointer" htmlFor={`gym_yes_${index}_${exercise}`}>Yes</label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name={`gym_${index}_${exercise}`} id={`gym_no_${index}_${exercise}`} value="no" checked={row.gymExercises?.[exercise]?.done === "no"} onChange={(e) => handleGymChange(index, exercise, "done", e.target.value)} />
                                                            <label className="form-check-label cursor-pointer" htmlFor={`gym_no_${index}_${exercise}`}>No</label>
                                                        </div>
                                                    </div>
                                                    {row.gymExercises?.[exercise]?.done === "yes" && (
                                                        <div className="mt-2">
                                                            <input type="text" className="form-control form-control-sm" placeholder="Duration (e.g., 20 min)" value={row.gymExercises?.[exercise]?.duration || ""} onChange={(e) => handleGymChange(index, exercise, "duration", e.target.value)} />
                                                        </div>
                                                    )}
                                                    {row.gymExercises?.[exercise]?.done === "no" && (
                                                        <div className="mt-2">
                                                            <input type="text" className="form-control form-control-sm" placeholder="Reason" value={row.gymExercises?.[exercise]?.reason || ""} onChange={(e) => handleGymChange(index, exercise, "reason", e.target.value)} />
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={addRow}
                    disabled={isSubmitting} // Add this
                >
                    <i className="ri-add-line me-2"></i> Add New Row
                </button>
                <div className="my-4"></div>

                {/* Document Information */}
                <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3 px-4 py-2 text-center">
                    Document Information
                </small>

                <div className="row g-3">
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" value="Weekly Clients Exercise Schedule" readOnly />
                            <label>Document Name</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="date" className="form-control" name="effectiveDate" value={formData.effectiveDate || ""} onChange={handleChange} />
                            <label>Effective Date</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="approvedBy" value={formData.approvedBy || ""} onChange={handleChange} />
                            <label>Approved By</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="date" className="form-control" name="approvedDate" value={formData.approvedDate || ""} onChange={handleChange} />
                            <label>Approved Date</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="text" className="form-control" name="nextRevisionBy" value={formData.nextRevisionBy || ""} onChange={handleChange} />
                            <label>Next Revision By</label>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="form-floating form-floating-outline">
                            <input type="date" className="form-control" name="nextRevisionDate" value={formData.nextRevisionDate || ""} onChange={handleChange} />
                            <label>Next Revision Date</label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExerciseScheduleForm;